// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__27OlJ","itemTitle":"ClientEmergencyInfo_itemTitle__3iTJn","itemText":"ClientEmergencyInfo_itemText__2JlR9"};